"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var forms_1 = require("@angular/forms");
var _1 = require("./");
var TripDetailsModule = (function () {
    function TripDetailsModule() {
    }
    return TripDetailsModule;
}());
TripDetailsModule = __decorate([
    core_1.NgModule({
        imports: [
            common_1.CommonModule,
            forms_1.FormsModule,
            forms_1.ReactiveFormsModule
        ],
        declarations: [
            _1.TripDetailsComponent,
            _1.TripProvidersComponent,
            _1.TripDatesComponent,
            _1.TripDestinationComponent
        ],
        exports: [
            _1.TripDetailsComponent,
            _1.TripProvidersComponent,
            _1.TripDatesComponent,
            _1.TripDestinationComponent
        ]
    })
], TripDetailsModule);
exports.TripDetailsModule = TripDetailsModule;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/trip-details/trip-details.module.js